import { useState, CSSProperties } from "react";
import ClipLoader from "react-spinners/RotateLoader";
import { useSelector } from "react-redux";

const override: CSSProperties = {
    display: 'flex',
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    borderWidth: "3px",
};

function Spinner() {
  const { userCompany } = useSelector((state: any) => state.auth);
  return (
    <div className="sweet-loading">
      <ClipLoader
        color={userCompany?.main_color || "rgba(170, 17, 103)"}
        loading={true}
        cssOverride={override}
        size={15}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  );
}

export default Spinner;